import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
// Import from date-fns
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//helper function
//import CustomDatePicker from "../input/CustomDatePicker";
import { format, isValid, parse, parseISO } from 'date-fns';
import React, { useEffect, useState } from 'react';

import updateDB from '../../../utils/updateDB';
import LoadingScreen from '../../loading/LoadingScreen';

const GolfCourseGreenFees = ({
  course,
  clubCourseMapping,
  greenFees,
  reciprocalsClean,
  user,
  editableCourses,
  editPermissions,
  username,
}) => {
  const [greenFeesHolder, setGreenFeesHolder] = useState(greenFees || {});
  const [editableFields, setEditableFields] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [lastEditedBy, setLastEditedBy] = useState(
    greenFees && greenFees.last_edited_by
      ? greenFees.last_edited_by[greenFees.last_edited_by.length - 1]
      : '',
  );
  const [lastEditedTime, setLastEditedTime] = useState(
    greenFees && greenFees.last_edited_time
      ? greenFees.last_edited_time[greenFees.last_edited_time.length - 1]
      : '',
  );

  //console.log("GF", greenFees)
  //console.log("GFH", greenFeesHolder);
  //console.log(username);

  const canEdit = () => {
    if (!user) return false;
    if (editPermissions === 'Advanced' || editPermissions === 'Ambassador')
      return true;
    if (
      (editPermissions === 'Basic' ||
        editPermissions === 'Ambassador' ||
        editPermissions === 'Editor') &&
      Array.isArray(editableCourses) &&
      editableCourses.includes(course.course_name)
    ) {
      return true;
    }
    return false;
  };

  const generateInputField = (
    value,
    handleInputChange,
    handleBlur,
    key,
    type = 'number',
  ) => {
    //console.log("Value for key", key, ":", value);
    // If the user doesn't have the required permissions or the field is not editable, return just the value without input
    if (!canEdit() || !isEditMode || !editableFields[key]) {
      if (type === 'date' && value) {
        let parsedDate;
        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
          // Check if value is in ISO format
          parsedDate = parseISO(value);
        } else {
          // Try to parse the date using a different format (e.g., "d MMM")
          parsedDate = parse(value, 'd MMM', new Date());
        }

        if (isValid(parsedDate)) {
          return format(parsedDate, 'd MMM');
        } else {
          console.error('Invalid date:', value);
          return 'Invalid Date';
        }
      }
      // Explicitly check for a value of 0 or "0.00" and return a hyphen,if NULL return blank
      if (parseFloat(value) === 0) {
        return '-';
      }
      return value || '-'; // Return the value directly if it's not a date, or a hyphen if the value is falsy
    }

    if (type === 'date') {
      // Set a default year of 2023 if the current year is before that
      const currentDate = new Date();
      if (currentDate.getFullYear() < 2023) {
        currentDate.setFullYear(2023, 0, 1);
      }

      return (
        <>
          <div className="flex flex-col justify-center items-center">
            <input
              type="date"
              value={value ? new Date(value).toISOString().split('T')[0] : ''}
              onChange={(e) => {
                const newGreenFeesHolder = {
                  ...greenFeesHolder,
                  [key]: e.target.value,
                };
                setGreenFeesHolder(newGreenFeesHolder);
                updateDB(
                  'green_fees',
                  { [key]: e.target.value },
                  'id',
                  greenFeesHolder.id,
                ).catch((error) => {
                  console.error('Error updating database:', error);
                });
              }}
              className="max-w-[55px] px-0 sm:max-w-[75px] sm:px-2 sm:pr-3 max-h-[25px] text-gray-700 text-xs text-left"
            />
            <button
              className="flex mt-1 border border-white rounded-md text-xs mx-auto font-normal px-1"
              onClick={() => {
                const newGreenFeesHolder = {
                  ...greenFeesHolder,
                  [key]: null,
                };
                setGreenFeesHolder(newGreenFeesHolder);
                updateDB(
                  'green_fees',
                  { [key]: null },
                  'id',
                  greenFeesHolder.id,
                )
                  .then(() => {
                    setEditableFields({
                      ...editableFields,
                      [key]: false,
                    });
                  })
                  .catch((error) => {
                    console.error('Error updating database:', error);
                  });
              }}
            >
              Mark N/A
            </button>
          </div>
        </>
      );
    }
    return (
      <input
        type={type}
        step={type === 'number' ? '0.01' : undefined}
        min={type === 'number' ? '0' : undefined}
        max={type === 'number' ? '9999.99' : undefined}
        defaultValue={value || ''}
        onChange={(e) => handleInputChange(e, key)}
        className="form-input block max-w-[50px] max-h-[25px] sm:h-fit mx-auto px-3 py-2 placeholder-gray-500 border border-slate-200 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5 text-xs md:max-w-[75px]"
      />
    );
  };

  useEffect(() => {
    if (greenFees) {
      setGreenFeesHolder(greenFees);
      //console.log("greenFeesHolder set to:", greenFees);
      const initialEditableFields = Object.keys(greenFees).reduce(
        (acc, key) => {
          acc[key] = false; // Set all fields as non-editable by default
          return acc;
        },
        {},
      );
      setEditableFields(initialEditableFields);
    }
  }, [greenFees]);

  const handleInputChange = (e, key) => {
    //console.log("Event:", e);
    //console.log("Key:", key);
    let value = e.target.value;
    if (value instanceof Date) {
      value = value.toISOString();
    }
    setGreenFeesHolder({
      ...greenFeesHolder,
      [key]: value,
    });
  };

  const handleBlur = (key) => {
    //console.log(`Blur event triggered for key: ${key}`);
    updateDB(
      'green_fees',
      { [key]: greenFeesHolder[key] },
      'id',
      greenFeesHolder.id,
    )
      .then(() => {
        //console.log(`Update successful for key: ${key}`);
        setEditableFields({
          ...editableFields,
          [key]: false,
        });
      })
      .catch((error) => {
        console.error('Error updating database:', error);
      });
  };

  if (!course) {
    return <LoadingScreen type="spin" color="#000" />;
  }

  const handleEditTable = () => {
    const updatedEditableFields = Object.keys(greenFeesHolder).reduce(
      (acc, key) => {
        acc[key] = true; // Set all fields as editable
        return acc;
      },
      {},
    );
    setEditableFields(updatedEditableFields);
    setIsEditMode(true);
  };

  const saveAllChanges = () => {
    const current_date = new Date().toISOString().slice(0, 10);

    const editedByArray = Array.isArray(greenFees.last_edited_by)
      ? [...greenFees.last_edited_by, username]
      : [username];

    const editedTimeArray = Array.isArray(greenFees.last_edited_time)
      ? [...greenFees.last_edited_time, current_date]
      : [current_date];

    // Construct the entire update object first
    const updates = {
      ...greenFeesHolder, // Ensure we update all green fee related data
      last_edited_by: editedByArray,
      last_edited_time: editedTimeArray,
    };

    // Now, make a single call to update the database with all required data
    updateDB('green_fees', updates, 'id', greenFeesHolder.id)
      .then(() => {
        setIsEditMode(false);
        // Update the local state to reflect the last edit immediately
        setLastEditedBy(username);
        setLastEditedTime(current_date);
      })
      .catch((error) => {
        console.error('Error updating database:', error);
      });
  };

  return (
    <>
      <section id="golfCourseGreenFees" className="mt-1 w-full max-w-screen">
        <article className="w-full h-full py-6 prose max-w-none prose-sm text-left border border-gray-300 rounded-xl bg-white shadow-lg">
          <h2 className="text-center truncate px-6">
            Green Fees Table (
            {greenFeesHolder && greenFeesHolder.currency
              ? greenFeesHolder.currency
              : ''}
            {''}): <span className="text-indigo-700">{course.course_name}</span>
          </h2>
          <div className="mx-auto max-w-3xl flex justify-between gap-x-2 sm:gap-x-10 px-2">
            {isEditMode ? (
              <>
                <button
                  onClick={() => setIsEditMode(!isEditMode)}
                  className="w-full py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-semibold rounded-lg flex items-center justify-center"
                >
                  <FontAwesomeIcon icon={solid('eject')} className="mr-2" />
                  Cancel
                </button>
                <button
                  onClick={saveAllChanges}
                  className="w-full py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-semibold rounded-lg flex items-center justify-center"
                >
                  <FontAwesomeIcon
                    icon={solid('floppy-disk')}
                    className="mr-2"
                  />
                  Save Changes
                </button>
              </>
            ) : canEdit() ? (
              <button
                onClick={handleEditTable}
                className="mx-auto max-w-[200px] w-full py-2 px-4 bg-blue-500 hover:bg-blue-700 text-white font-semibold rounded-lg flex items-center justify-center"
              >
                <FontAwesomeIcon icon={solid('user-pen')} className="mr-2" />
                Edit Table
              </button>
            ) : null}
          </div>

          {lastEditedBy && lastEditedTime && (
            <p className="text-center text-xs italic px-2">
              Last at {lastEditedTime}
            </p>
          )}

          <table className="mx-auto max-w-xl table-bordered border-2 border-slate-500 text-xs sm:text-sm">
            <thead className="bg-indigo-600 text-white">
              <tr>
                <th className="border border-slate-500 text-white hidden sm:table-cell">
                  Golf Course:
                </th>
                <th
                  className="border border-slate-500 text-white text-center pt-2"
                  colSpan={5}
                >
                  {course.course_name}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td
                  className="font-bold bg-slate-700 text-white text-center align-middle sm:hidden"
                  colSpan={5}
                >
                  Season
                </td>
              </tr>

              <tr>
                <td
                  className="font-bold bg-slate-500 text-white align-middle hidden sm:table-cell"
                  rowSpan={2}
                >
                  Season
                </td>
                <td className="font-semibold bg-slate-500 text-white">Name:</td>
                <td className=" bg-slate-500 text-white">Low</td>
                <td className=" bg-slate-500 text-white">Shoulder1</td>
                <td className=" bg-slate-500 text-white">High</td>
                <td className=" bg-slate-500 text-white">Shoulder2</td>
              </tr>

              <tr>
                <td className="font-semibold bg-slate-500 text-white border border-slate-500">
                  Start Date:
                </td>
                <td className="bg-slate-500 text-white">
                  {generateInputField(
                    greenFeesHolder && greenFeesHolder.low_season_start
                      ? greenFeesHolder.low_season_start
                      : '',
                    (e) => handleInputChange(e, 'low_season_start'),
                    null,
                    'low_season_start',
                    'date',
                  )}
                </td>
                <td className="bg-slate-500 text-white">
                  {generateInputField(
                    greenFeesHolder && greenFeesHolder.shoulder_season_1_start
                      ? greenFeesHolder.shoulder_season_1_start
                      : '',
                    (e) => handleInputChange(e, 'shoulder_season_1_start'),
                    null,
                    'shoulder_season_1_start',
                    'date',
                  )}
                </td>
                <td className="bg-slate-500 text-white">
                  {generateInputField(
                    greenFeesHolder && greenFeesHolder.high_season_start
                      ? greenFeesHolder.high_season_start
                      : '',
                    (e) => handleInputChange(e, 'high_season_start'),
                    null,
                    'high_season_start',
                    'date',
                  )}
                </td>
                <td className="bg-slate-500 text-white">
                  {generateInputField(
                    greenFeesHolder && greenFeesHolder.shoulder_season_2_start
                      ? greenFeesHolder.shoulder_season_2_start
                      : '',
                    (e) => handleInputChange(e, 'shoulder_season_2_start'),
                    null,
                    'shoulder_season_2_start',
                    'date',
                  )}
                </td>
              </tr>

              <tr>
                <td
                  className="font-bold bg-slate-700 text-white text-center align-middle sm:hidden"
                  colSpan={5}
                >
                  Weekday
                </td>
              </tr>

              <tr className="h-[40px]">
                <td
                  className="font-bold bg-slate-100 hidden sm:table-cell"
                  rowSpan={4}
                >
                  Weekday
                </td>
                <td className="align-middle">18 holes</td>
                <td className="align-middle">
                  {generateInputField(
                    greenFeesHolder.low_weekday || '',
                    (e) => handleInputChange(e, 'low_weekday'),
                    handleBlur,
                    'low_weekday',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    greenFeesHolder.shoulder_1_weekday || '',
                    (e) => handleInputChange(e, 'shoulder_1_weekday'),
                    handleBlur,
                    'shoulder_1_weekday',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    greenFeesHolder.high_weekday || '',
                    (e) => handleInputChange(e, 'high_weekday'),
                    handleBlur,
                    'high_weekday',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    greenFeesHolder.shoulder_2_weekday || '',
                    (e) => handleInputChange(e, 'shoulder_2_weekday'),
                    handleBlur,
                    'shoulder_2_weekday',
                  )}
                </td>
              </tr>

              <tr className="h-[40px]">
                <td className="align-middle">Day Rate</td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder && greenFeesHolder.low_weekday_rate) || '',
                    (e) => handleInputChange(e, 'low_weekday_rate'),
                    handleBlur,
                    'low_weekday_rate',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder &&
                      greenFeesHolder.shoulder_1_weekday_rate) ||
                      '',
                    (e) => handleInputChange(e, 'shoulder_1_weekday_rate'),
                    handleBlur,
                    'shoulder_1_weekday_rate',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder && greenFeesHolder.high_weekday_rate) ||
                      '',
                    (e) => handleInputChange(e, 'high_weekday_rate'),
                    handleBlur,
                    'high_weekday_rate',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder &&
                      greenFeesHolder.shoulder_2_weekday_rate) ||
                      '',
                    (e) => handleInputChange(e, 'shoulder_2_weekday_rate'),
                    handleBlur,
                    'shoulder_2_weekday_rate',
                  )}
                </td>
              </tr>
              <tr className="h-[40px]">
                <td className="align-middle">Twighlight</td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder &&
                      greenFeesHolder.low_weekday_twighlight) ||
                      '',
                    (e) => handleInputChange(e, 'low_weekday_twighlight'),
                    handleBlur,
                    'low_weekday_twighlight',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder &&
                      greenFeesHolder.shoulder_1_weekday_twighlight) ||
                      '',
                    (e) =>
                      handleInputChange(e, 'shoulder_1_weekday_twighlight'),
                    handleBlur,
                    'shoulder_1_weekday_twighlight',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder &&
                      greenFeesHolder.high_weekday_twighlight) ||
                      '',
                    (e) => handleInputChange(e, 'high_weekday_twighlight'),
                    handleBlur,
                    'high_weekday_twighlight',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder &&
                      greenFeesHolder.shoulder_2_weekday_twighlight) ||
                      '',
                    (e) =>
                      handleInputChange(e, 'shoulder_2_weekday_twighlight'),
                    handleBlur,
                    'shoulder_2_weekday_twighlight',
                  )}
                </td>
              </tr>
              <tr className="h-[40px]">
                <td className="align-middle">County Card</td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder && greenFeesHolder.low_weekday_cc) || '',
                    (e) => handleInputChange(e, 'low_weekday_cc'),
                    handleBlur,
                    'low_weekday_cc',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder &&
                      greenFeesHolder.shoulder_1_weekday_cc) ||
                      '',
                    (e) => handleInputChange(e, 'shoulder_1_weekday_cc'),
                    handleBlur,
                    'shoulder_1_weekday_cc',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder && greenFeesHolder.high_weekday_cc) || '',
                    (e) => handleInputChange(e, 'high_weekday_cc'),
                    handleBlur,
                    'high_weekday_cc',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder &&
                      greenFeesHolder.shoulder_2_weekday_cc) ||
                      '',
                    (e) => handleInputChange(e, 'shoulder_2_weekday_cc'),
                    handleBlur,
                    'shoulder_2_weekday_cc',
                  )}
                </td>
              </tr>

              <tr>
                <td
                  className="font-bold bg-slate-700 text-white text-center align-middle sm:hidden"
                  colSpan={5}
                >
                  Weekend
                </td>
              </tr>

              <tr className="h-[40px]">
                <td
                  className="font-bold bg-indigo-100 hidden sm:table-cell"
                  rowSpan={4}
                >
                  Weekend
                </td>
                <td className="align-middle">18 holes</td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder && greenFeesHolder.low_weekend) || '',
                    (e) => handleInputChange(e, 'low_weekend'),
                    handleBlur,
                    'low_weekend',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder && greenFeesHolder.shoulder_1_weekend) ||
                      '',
                    (e) => handleInputChange(e, 'shoulder_1_weekend'),
                    handleBlur,
                    'shoulder_1_weekend',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder && greenFeesHolder.high_weekend) || '',
                    (e) => handleInputChange(e, 'high_weekend'),
                    handleBlur,
                    'high_weekend',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder && greenFeesHolder.shoulder_2_weekend) ||
                      '',
                    (e) => handleInputChange(e, 'shoulder_2_weekend'),
                    handleBlur,
                    'shoulder_2_weekend',
                  )}
                </td>
              </tr>
              <tr className="h-[40px]">
                <td className="align-middle">Day Rate</td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder && greenFeesHolder.low_weekend_rate) || '',
                    (e) => handleInputChange(e, 'low_weekend_rate'),
                    handleBlur,
                    'low_weekend_rate',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder &&
                      greenFeesHolder.shoulder_1_weekend_rate) ||
                      '',
                    (e) => handleInputChange(e, 'shoulder_1_weekend_rate'),
                    handleBlur,
                    'shoulder_1_weekend_rate',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder && greenFeesHolder.high_weekend_rate) ||
                      '',
                    (e) => handleInputChange(e, 'high_weekend_rate'),
                    handleBlur,
                    'high_weekend_rate',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder &&
                      greenFeesHolder.shoulder_2_weekend_rate) ||
                      '',
                    (e) => handleInputChange(e, 'shoulder_2_weekend_rate'),
                    handleBlur,
                    'shoulder_2_weekend_rate',
                  )}
                </td>
              </tr>
              <tr className="h-[40px]">
                <td className="align-middle">Twighlight</td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder &&
                      greenFeesHolder.low_weekend_twighlight) ||
                      '',
                    (e) => handleInputChange(e, 'low_weekend_twighlight'),
                    handleBlur,
                    'low_weekend_twighlight',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder &&
                      greenFeesHolder.shoulder_1_weekend_twighlight) ||
                      '',
                    (e) =>
                      handleInputChange(e, 'shoulder_1_weekend_twighlight'),
                    handleBlur,
                    'shoulder_1_weekend_twighlight',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder &&
                      greenFeesHolder.high_weekend_twighlight) ||
                      '',
                    (e) => handleInputChange(e, 'high_weekend_twighlight'),
                    handleBlur,
                    'high_weekend_twighlight',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder &&
                      greenFeesHolder.shoulder_2_weekend_twighlight) ||
                      '',
                    (e) =>
                      handleInputChange(e, 'shoulder_2_weekend_twighlight'),
                    handleBlur,
                    'shoulder_2_weekend_twighlight',
                  )}
                </td>
              </tr>
              <tr className="h-[40px]">
                <td className="align-middle">County Card</td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder && greenFeesHolder.low_weekend_cc) || '',
                    (e) => handleInputChange(e, 'low_weekend_cc'),
                    handleBlur,
                    'low_weekend_cc',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder &&
                      greenFeesHolder.shoulder_1_weekend_cc) ||
                      '',
                    (e) => handleInputChange(e, 'shoulder_1_weekend_cc'),
                    handleBlur,
                    'shoulder_1_weekend_cc',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder && greenFeesHolder.high_weekend_cc) || '',
                    (e) => handleInputChange(e, 'high_weekend_cc'),
                    handleBlur,
                    'high_weekend_cc',
                  )}
                </td>
                <td className="align-middle">
                  {generateInputField(
                    (greenFeesHolder &&
                      greenFeesHolder.shoulder_2_weekend_cc) ||
                      '',
                    (e) => handleInputChange(e, 'shoulder_2_weekend_cc'),
                    handleBlur,
                    'shoulder_2_weekend_cc',
                  )}
                </td>
              </tr>

              <tr>
                <td
                  className="font-bold bg-slate-700 text-white text-center align-middle sm:hidden"
                  colSpan={5}
                >
                  Concessions<br></br>{' '}
                  <span className="italic font-thin text-xs">
                    (All Seasons default to highest rate)
                  </span>
                </td>
              </tr>

              <tr>
                <td className="font-bold bg-slate-500 text-white align-middle hidden sm:table-cell">
                  Season
                </td>
                <td className="font-bold bg-slate-500 text-white align-middle hidden sm:table-cell">
                  Name
                </td>
                <td
                  className="font-bold bg-slate-500 text-white text-center hidden sm:table-cell"
                  colSpan={4}
                >
                  All Seasons<br></br>
                  <span className="italic font-thin text-xs">
                    (We show the highest rate across the seasons)
                  </span>
                </td>
              </tr>

              <tr className="h-[40px]">
                <td
                  className="font-bold bg-slate-100 hidden sm:table-cell"
                  rowSpan={3}
                >
                  Concession
                </td>
                <td className="align-middle">Guest</td>
                <td className="align-middle text-center" colSpan={4}>
                  {generateInputField(
                    (greenFeesHolder && greenFeesHolder.max_guest_rate) || '',
                    (e) => handleInputChange(e, 'max_guest_rate'),
                    handleBlur,
                    'max_guest_rate',
                  )}
                </td>
              </tr>
              <tr className="h-[40px]">
                <td className="align-middle">Junior</td>
                <td className="align-middle text-center" colSpan={4}>
                  {generateInputField(
                    (greenFeesHolder && greenFeesHolder.max_junior_rate) || '',
                    (e) => handleInputChange(e, 'max_junior_rate'),
                    handleBlur,
                    'max_junior_rate',
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </article>
      </section>
    </>
  );
};

export default GolfCourseGreenFees;
